/* -- Generated File: Do Not Edit ------------------------------------------ */
export const borderWidths = {
  borderWidth0: '1px',
  borderWidth1: '2px',
  borderWidth2: '4px',
};

export default borderWidths;
/* -- Generated File: Do Not Edit ------------------------------------------ */
